<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <div v-if="!adsReady" class="table-loading-container">
          <img src="/img/wifi-loading.gif" alt="loading" class="loading-table">
        </div>
      </b-col>
    </b-row>
    <b-row v-if="adsReady">
      <b-col>
        <h3>Ads</h3>
        <div v-for="ad in activeEnabledAds" :key="ad._id">
          <b-card>
            <div slot="header">
              Preview Ad: {{ad.name}}
            </div>
            <b-card-body>
              <div v-if="ad.type==='image'">
                <a :href="ad.link" target="_blank"><img :src="`${mobileUrl}/img/uploads/${ad._id}.${ad.imageExt}`" class="responsive"></a>
              </div>
              <div v-if="ad.type==='html'" class="preview-window">
                <div v-html="ad.html"></div>
              </div>
            </b-card-body>
          </b-card>
        </div>  
      </b-col>
      <b-col>
        <h3>Surveys</h3>
        <b-card v-for="survey in surveys" :key="survey.surveyId">
          <div slot="header">
            {{survey.surveyName}}
          </div>
          <b-card-body>
            <div class="mb-4" v-if="survey.statCharts.length > 0" v-for="statChart in survey.statCharts" :key="statChart.questionId">
              <bar-chart :chart-data="statChart" :options="chartOptions" :height="200"></bar-chart>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';
import BarChart from './charts/BarChart'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'

export default {
  name: 'dashboard',
  components: {
    BarChart
  },
  data () {
    return {
      adsReady: false,
      surveysReady: false,
      ads: [],
      surveys: []
    }
  },
  computed: {
    mobileUrl () {
      return process.env.VUE_APP_MOBILE_URL;
    },
    dashboardReady () {
      return this.adsReady && this.surveysReady;
    },
    surveyStats () {
      return this.$store.getters.surveyStats;
    },
    chartOptions () {
      let scope = this;
      return {
        scales: {
          xAxes: [{
            ticks: {
              min: 0,
              callback: function(value, index, values) {
                return Math.floor(value);
              }
            }
          }]
        }
      }
    },
    activeEnabledAds () {
      return this.$store.getters.activeEnabledAds;
    },
    currentUser () {
      return this.$store.getters.currentUser;
    }
  },
  methods: {
    getAds: function () {
      let scope = this;
      scope.adsReady = false;
      let where = {
        company: scope.currentUser.company
      }
      where = '&where=' + JSON.stringify(where);
      scope.$store.dispatch('getAds', where).then(result => {
        scope.adsReady = true;
      }, error => {
        console.log(error);
      })
    },
    getSurveys: function () {
      let scope = this;
      scope.$store.dispatch('getSurveyStats', {
        id: '',
        dashboard: true,
        companyId: scope.currentUser.company
      }).then((result => {
        scope.surveyStats.forEach(surveyStat => {

          let survey = {
            surveyName: surveyStat.surveyName,
            statCharts: []
          };

          surveyStat.questions.forEach((question) => {
            survey.statCharts.push({
              labels: question.options.map(option => option.optionName),
              datasets: [
                {
                  label: question.questionName,
                  backgroundColor: hexToRgba('#592b8b', 10),
                  borderColor: '#592b8b',
                  pointHoverBackgroundColor: '#fff',
                  borderWidth: 1,
                  data: question.options.map(option => option.optionCount)
                }
              ]
            })
          })

          scope.surveys.push(survey);

        });
      }), error => {
        console.log(error);
      })
    },
    conversion (item) {
      if(item.impressions && item.clicks) {
        let rate = (item.clicks / item.impressions) * 100;
        return Math.floor(rate);
      }
      return 0;
    }
  },
  created () {
    this.getAds();
    this.getSurveys();
  }
}
</script>

<style>
  
</style>
